import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import * as action from '../action';
import * as c from '../constant';

function EBillsContent({ showTransaction, isLoading, match, taxpayer }) {
  const selectedTransaction = match.params.id;

  const updateData = () => {
    showTransaction(selectedTransaction);
  };

  useEffect(() => {
    if (!_.isEmpty(selectedTransaction)) {
      updateData();
    }
  }, []);

  useEffect(() => {
    if (!_.isEmpty(selectedTransaction)) {
      updateData();
    }
  }, [selectedTransaction]);

  const getInitials = cString => {
    if (cString) {
      const val = cString.replace(/\[^a-zA-Z- ]/g, '').match(/\b(\w)/g);
      const strFirstTwo = val.slice(0, 2);
      const final = strFirstTwo.join('');
      return final.toUpperCase();
    }
    return null;
  };

  const profile = _.get(taxpayer, 'included.taxPayer');

  return (
    <>
      <div className="card-section-content container-fluid">
        {isLoading && (
          <div className="loading">
            <div className="spinner text-center">
              <span className="fas fa-1x fa-spin fa-spinner" />
            </div>
          </div>
        )}
        <div className="right-section-content">
          {/* GRAY HIGHLIGHT */}
          <div className="row highlight d-flex align-items-center mx-3 py-3">
            <div className="col-12 px-0 mt-0 mb-1">
              {/* BORDER */}
              <div className="card border-primary">
                <div className="container-fluid py-1">
                  <div className="p-0 d-flex flex-nowrap mb-3 w-100">
                    <div className="d-flex round-image justify-content-center">
                      <h3 className="d-flex align-items-center initials mb-0">
                        {_.get(taxpayer, 'attributes.photo') !==
                        '-/format/jpeg/' ? (
                          <img
                            alt="Client Profile"
                            src={_.get(profile, 'attributes.photo')}
                          />
                        ) : (
                          getInitials(
                            `${_.get(profile, 'attributes.first_name')} ${_.get(
                              profile,
                              'attributes.last_name'
                            )}`
                          )
                        )}
                      </h3>
                    </div>
                    <div className="d-flex ml-4 align-items-center">
                      <h1 className="transaction-company m-0">
                        {`${_.get(profile, 'attributes.first_name') ||
                          '-'} ${_.get(profile, 'attributes.middle_name') ||
                          ''} ${_.get(profile, 'attributes.last_name') ||
                          ''} ${_.get(profile, 'attributes.extension_name') ||
                          ''}`}
                      </h1>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row mb-1 pb-1 px-3 ">
            <div className="col-12 border rounded p-3 mb-3">
              <table className="transaction-table table table-borderless table-sm">
                <tbody>
                  <tr>
                    <td className="text-success" width="250">
                      Transaction Details
                    </td>
                  </tr>
                  <tr>
                    <td className="text-dark" width="250">
                      Transaction
                    </td>
                    <td className="text-dark" width="1">
                      :
                    </td>
                    <td>
                      <b>
                        {(
                          _.get(
                            taxpayer,
                            'included.transaction.attributes.description'
                          ) || '--'
                        ).toUpperCase()}
                      </b>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-dark" width="250">
                      Mobile Number
                    </td>
                    <td className="text-dark" width="1">
                      :
                    </td>
                    <td>
                      <b>
                        {(
                          _.get(taxpayer, 'attributes.mobile_number') || '--'
                        ).toUpperCase()}
                      </b>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-dark" width="250">
                      Amount
                    </td>
                    <td className="text-dark" width="1">
                      :
                    </td>
                    <td>
                      <b>{_.get(taxpayer, 'attributes.amount') || '--'}</b>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-dark" width="250">
                      Reference Number
                    </td>
                    <td className="text-dark" width="1">
                      :
                    </td>
                    <td>
                      <b>
                        {(
                          _.get(
                            taxpayer,
                            'included.transaction.attributes.detail.reference_number'
                          ) || '--'
                        ).toUpperCase()}
                      </b>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-dark" width="250">
                      Payment Status
                    </td>
                    <td className="text-dark" width="1">
                      :
                    </td>
                    <td>
                      <b>
                        {(
                          _.get(
                            taxpayer,
                            'included.transaction.attributes.detail.status'
                          ) || '--'
                        ).toUpperCase()}
                      </b>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-dark" width="250">
                      Remarks
                    </td>
                    <td className="text-dark" width="1">
                      :
                    </td>
                    <td>
                      <b>
                        {(
                          _.get(taxpayer, 'attributes.remarks') || '--'
                        ).toUpperCase()}
                      </b>
                    </td>
                  </tr>

                  <tr>
                    <td className="text-success" width="250">
                      Profile Details
                    </td>
                  </tr>
                  <tr>
                    <td className="text-dark" width="250">
                      Last Name
                    </td>
                    <td className="text-dark" width="1">
                      :
                    </td>
                    <td>
                      <b>
                        {(
                          _.get(profile, 'attributes.last_name') || '--'
                        ).toUpperCase()}
                      </b>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-dark" width="250">
                      Middle Name
                    </td>
                    <td className="text-dark" width="1">
                      :
                    </td>
                    <td>
                      <b>
                        {(
                          _.get(profile, 'attributes.middle_name') || '--'
                        ).toUpperCase()}
                      </b>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-dark" width="250">
                      First Name
                    </td>
                    <td className="text-dark" width="1">
                      :
                    </td>
                    <td>
                      <b>
                        {(
                          _.get(profile, 'attributes.first_name') || '--'
                        ).toUpperCase()}
                      </b>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-dark" width="250">
                      Extension Name
                    </td>
                    <td className="text-dark" width="1">
                      :
                    </td>
                    <td>
                      <b>
                        {(
                          _.get(profile, 'attributes.extension_name') || '--'
                        ).toUpperCase()}
                      </b>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-dark" width="250">
                      Address
                    </td>
                    <td className="text-dark" width="1">
                      :
                    </td>
                    <td>
                      <b>
                        {_.get(profile, 'attributes.region_name') || '--'}
                        {''}
                        {_.get(profile, 'attributes.province_name') ||
                          '--'}{' '}
                        {_.get(profile, 'attributes.municipality_name') || '--'}{' '}
                        {_.get(profile, 'attributes.barangay_name') || '--'}{' '}
                        {_.get(profile, 'attributes.street') || '--'}
                      </b>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-dark" width="250">
                      Gender
                    </td>
                    <td className="text-dark" width="1">
                      :
                    </td>
                    <td>
                      <b>
                        {(
                          _.get(profile, 'attributes.gender') || '--'
                        ).toUpperCase()}
                      </b>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-dark" width="250">
                      Civil Status
                    </td>
                    <td className="text-dark" width="1">
                      :
                    </td>
                    <td>
                      <b>
                        {(
                          _.get(profile, 'attributes.civil_status') || '--'
                        ).toUpperCase()}
                      </b>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-dark" width="250">
                      Citizenship
                    </td>
                    <td className="text-dark" width="1">
                      :
                    </td>
                    <td>
                      <b>
                        {(
                          _.get(profile, 'attributes.citizenship_name') || '--'
                        ).toUpperCase()}
                      </b>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-dark" width="250">
                      Place of Birth
                    </td>
                    <td className="text-dark" width="1">
                      :
                    </td>
                    <td>
                      <b>
                        {(
                          _.get(
                            profile,
                            'attributes.place_of_birth_region_name'
                          ) || '--'
                        ).toUpperCase()}{' '}
                        {(
                          _.get(
                            profile,
                            'attributes.place_of_birth_province_name'
                          ) || '--'
                        ).toUpperCase()}{' '}
                        {(
                          _.get(
                            profile,
                            'attributes.place_of_birth_municipality_name'
                          ) || '--'
                        ).toUpperCase()}
                      </b>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-dark" width="250">
                      Date of Birth
                    </td>
                    <td className="text-dark" width="1">
                      :
                    </td>
                    <td>
                      <b>{_.get(profile, 'attributes.birth_date') || '--'}</b>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-dark" width="250">
                      Profession/Occupation Business
                    </td>
                    <td className="text-dark" width="1">
                      :
                    </td>
                    <td>
                      <b>
                        {(
                          _.get(profile, 'attributes.profession_name') || '--'
                        ).toUpperCase()}
                      </b>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-dark" width="250">
                      Height
                    </td>
                    <td className="text-dark" width="1">
                      :
                    </td>
                    <td>
                      <b>
                        {(
                          _.get(profile, 'attributes.height') || '--'
                        ).toUpperCase()}
                      </b>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-dark" width="250">
                      Weight
                    </td>
                    <td className="text-dark" width="1">
                      :
                    </td>
                    <td>
                      <b>
                        {(
                          _.get(profile, 'attributes.weight') || '--'
                        ).toUpperCase()}
                      </b>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

EBillsContent.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  taxpayer: PropTypes.instanceOf(Object).isRequired,
  showTransaction: PropTypes.instanceOf(Function).isRequired,
  isLoading: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ api }) => ({
  taxpayer:
    {
      ...(_.get(api, `${c.SHOW_TRANSACTION}.item`) || {}),
    } || {},
  isLoading: api.loading.indexOf(c.SHOW_TRANSACTION) > -1,
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, action)]);

export default enhance(EBillsContent);
